import React from 'react'
import { Segmented } from 'antd';

const Tab = ({alignValue, onChange,options=[]}) => {
  return (
     <Segmented
        value={alignValue}
        style={{ marginBottom: 8 }}
        onChange={onChange}
        options={options}
      />
  )
}

export default Tab